export const Week = (day) => `<div>${day}</div>`;
